// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__3zvWK","error":"Button_error__1Kbox","success":"Button_success__2nX_F","primary":"Button_primary__3pP02"};